import {
  GET_ROOM_CONFERENCE,
  GET_SINGLE_ROOM_CONFERENCE,
  CREATE_ROOM_CONFERENCE,
  UPDATE_ROOM_CONFERENCE,
} from "@actions/inventory/roomConference/types";

import {
  RoomConferenceState,
  RoomConferenceStateAction,
} from "@reducers/types/inventory/room-conference-state";
import dayjs from "dayjs";

export const initialState: RoomConferenceState = {
  isGetLoading: false,
  isGetSingleLoading: false,
  isUpdateLoading: false,
  isDeleteLoading: false,
  isCreateLoading: false,

  getError: null,
  getSingleError: null,
  createError: null,
  updateError: null,
  deleteError: null,

  getSuccess: false,
  getSingleSuccess: false,
  createSuccess: false,
  updateSuccess: false,
  deleteSuccess: false,

  getData: null,
  getSingleData: null,
};

const RoomConferenceReducer = (
  state: RoomConferenceState = initialState,
  action: RoomConferenceStateAction,
): RoomConferenceState => {
  const { type, payload } = action;

  switch (type) {
    // fetch
    case GET_ROOM_CONFERENCE.LOADING:
      return {
        ...state,
        isGetLoading: payload,
        getError: null,
        getData: null,
        createSuccess: false,
        createError: null,
        updateSuccess: false,
        updateError: null,
      };

    case GET_ROOM_CONFERENCE.ERROR:
      return {
        ...state,
        isGetLoading: false,
        getError: payload,
        getData: null,
      };

    case GET_ROOM_CONFERENCE.SUCCESS:
      return {
        ...state,
        isGetLoading: false,
        getError: null,
        getData: payload,
      };

    case GET_SINGLE_ROOM_CONFERENCE.LOADING:
      return {
        ...state,
        isGetSingleLoading: payload,
        getSingleError: null,
        getSingleData: null,
      };

    case GET_SINGLE_ROOM_CONFERENCE.ERROR:
      return {
        ...state,
        isGetSingleLoading: false,
        getSingleError: payload,
        getSingleData: null,
      };

    case GET_SINGLE_ROOM_CONFERENCE.SUCCESS: {
      const { data } = payload;

      data.bookingStartTime = `${dayjs(data?.bookingStartTime).format(
        "YYYY-MM-DD",
      )}  ${dayjs(data?.bookingStartTime).format("hh:mm:ss")}`;
      data.bookingEndTime = `${dayjs(data?.bookingEndTime).format(
        "YYYY-MM-DD",
      )}  ${dayjs(data?.bookingEndTime).format("hh:mm:ss")}`;

      return {
        ...state,
        isGetSingleLoading: false,
        getSingleError: null,
        getSingleData: { data },
      };
    }
    // create
    case CREATE_ROOM_CONFERENCE.LOADING:
      return {
        ...state,
        isCreateLoading: payload,
        createError: null,
        createSuccess: false,
      };

    case CREATE_ROOM_CONFERENCE.ERROR:
      return {
        ...state,
        isCreateLoading: false,
        createError: payload,
        createSuccess: false,
      };

    case CREATE_ROOM_CONFERENCE.SUCCESS:
      return {
        ...state,
        isCreateLoading: false,
        createError: null,
        createSuccess: true,
      };

    // update
    case UPDATE_ROOM_CONFERENCE.LOADING:
      return {
        ...state,
        isUpdateLoading: payload,
        updateError: null,
        updateSuccess: false,
      };

    case UPDATE_ROOM_CONFERENCE.ERROR:
      return {
        ...state,
        isUpdateLoading: false,
        updateError: payload,
        updateSuccess: false,
      };

    case UPDATE_ROOM_CONFERENCE.SUCCESS:
      return {
        ...state,
        isUpdateLoading: false,
        updateError: null,
        updateSuccess: true,
      };

    // case UPDATE_ROOM_CONFERENCE.SUCCESS:
    //   const newState = state.getData.data;

    //   const index = newState.findIndex(
    //     (item: RoomConference) => item.id === payload.id,
    //   );

    //   if (index >= 0) {
    //     // newState[index].name = payload.name;
    //     newState[index] = payload;
    //   }

    //   return {
    //     ...state,
    //     updateError: null,
    //     getData: {
    //       ...state.getData,
    //       data: newState,
    //     },
    //     isUpdateLoading: false,
    //   };

    default:
      return state;
  }
};

export default RoomConferenceReducer;
